import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { WarningMessage } from '@components-library/WarningMessage/WarningMessage';
import { keyMap } from '@locales/lokalise/keyMap';
import styles from './userUpdateBankDetails.styles.module.scss';

interface UserUpdateBankDetailsMessageProps {
  title: string;
  messages: string[];
  username: string;
  withUserName?: boolean;
}

export const UserUpdateBankDetailsMessage = ({
  title,
  messages,
  username,
  withUserName = true,
}: UserUpdateBankDetailsMessageProps) => {
  const { i18n } = useTranslation();

  return (
    <div>
      <WarningMessage type="warning" className={styles.warningMessage} title={i18n.t(title)} />
      {withUserName && (
        <p>
          <Trans values={{ username }} i18nKey={keyMap.commonDearUserName} components={{ b: <b /> }} />
        </p>
      )}
      {messages.map((key, index) => (
        <p key={index}>{i18n.t(key)}</p>
      ))}
    </div>
  );
};
